import { styled, css, Box } from '@mui/material'
import { ETableTextType, ITableColumns } from './Table.types'
import Text from '../Text'

export const TableWrapper = styled(Box)(
  () => css`
    width: 100%;
    height: 100%;
    display: flex;
    margin: 0;
    justify-content: center;
    align-items: center;
  `
)

export const TableContainer = styled(Box)(
  () => css`
    display: flex;
    flex-flow: column nowrap;
    width: 100%;
    border-radius: 4px;
  `
)

export const TableRow = styled(Box, {
  shouldForwardProp: (prop) => !['selected'].includes(String(prop))
})<{ selected?: boolean }>(
  ({ theme, selected = false }) => css`
    display: flex;
    flex-flow: row nowrap;
    width: 100%;
    background-color: ${theme.palette.background.default};
    margin: 8px 0;
    ${
      selected &&
      `
      background-color: ${theme.palette.grey[100]};
      `
    }
  }
`
)

export const TableHeading = styled(Box)(
  () => css`
    display: flex;
    flex-flow: row nowrap;
    width: 100%;
    font-size: 10px;
    font-style: normal;
    font-weight: 700;
    line-height: 130%;
  }
  `
)

export const TableRowItemHeader = styled(Box)(
  () => css`
      display: flex;
      flex: 1;
      font-size: 14px;
      padding: 8px 0;
      justify-content: center;
      align-items: center;
    }
     `
)

export const TableRowItem = styled(Box)(
  () => css`
    padding: 6px;
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
  }
   `
)

export const TableRowText = styled(Text)<
  Pick<ITableColumns<{ id: string }>, 'type'>
>(
  ({ type, theme }) => css`
    font-size: 11px;
    font-style: normal;
    font-weight: 600;
    line-height: 16px;
    color: ${theme.palette.text.primary};
     ${
       type === ETableTextType.bold &&
       `
      font-size: 12px;
      font-style: normal;
      font-weight: 900;
      line-height: 130%;
      `
     }
    ${
      type === ETableTextType.highlighted &&
      `
      font-size: 12px;
      font-style: normal;
      font-weight: 700;
      line-height: 90%;
      background-color: ${theme.palette.secondary.main};
      padding: 4px;
      border-radius: 4px;
      `
    }
    ${
      type === ETableTextType.price &&
      `
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 16px;
      color: ${theme.palette.primary.main};
      `
    }
  }
   `
)
